import { capitalize } from 'lodash';

export const segmentWebhookUrl = (pubKey) =>
  `https://app.clearbit.com/v1/webhooks/segment?authorization=${pubKey}`;

export function tagsjsSnippet(pubKey) {
  const domain = getTagsSourceDomain();
  const { protocol } = window.location;
  const src = `${protocol}//${domain}/v1/${pubKey}/tags.js`;

  return `<script src="${src}"></script>`;
}

const getTagsSourceDomain = () => {
  const { hostname, port } = window.location;

  if (hostname === 'x.clearbit.com' || hostname === 'app.clearbit.com') {
    return 'tag.clearbitscripts.com';
  } else if (hostname === 'localhost') {
    return `localhost:${port}`;
  }

  return hostname;
};

export const configurations = {
  javascript: 'javascript',
  segment: 'segment',
  google: 'google',
  googleConversion: 'google_conversion',
  pardot: 'pardot',
  salesforce: 'salesforce',
  salesforcesandbox: 'salesforcesandbox',
  slack: 'slack',
  facebook: 'facebook',
  hubspot: 'hubspot',
  marketo: 'marketo',
};

export const connectorStatuses = {
  active: 'active',
  disconnected: 'disconnected',
  error: 'error',
};

export const dataSources = {
  clearbitjs: 'clearbitjs',
  googleTagManager: 'google_tag_manager',
  segment: 'segment',
};

const serviceTrackNames = {
  [configurations.google]: 'google_oauth2',
};

export const googleAccountTypes = {
  google360: 'analytics_360_suite',
  standard: 'standard',
};

export const dimensionMappingStatuses = {
  active: 'active',
  paused: 'paused',
};

export const DIMENSION_LIMITS = {
  [googleAccountTypes.standard]: 20,
  [googleAccountTypes.google360]: 200,
};

export const revealTypeAttribute = {
  attributeType: 'Company',
  category: 'clearbit',
  label: 'Type',
  subCategory: null,
  value: 'type',
  __typename: 'Attribute',
};

export const defaultDimensionMapping = [
  {
    attribute: 'type',
    dimension: {
      label: 'Clearbit Type',
      index: null,
      value: null,
    },
  },
  {
    attribute: 'company->name',
    dimension: {
      label: 'Clearbit Company Name',
      index: null,
      value: null,
    },
  },
  {
    attribute: 'company->domain',
    dimension: {
      label: 'Clearbit Company Domain',
      index: null,
      value: null,
    },
  },
  {
    attribute: 'company->metrics->employees_range',
    dimension: {
      label: 'Clearbit Company Employees Range',
      index: null,
      value: null,
    },
  },
  {
    attribute: 'company->category->sub_industry',
    dimension: {
      label: 'Clearbit Company Sub Industry',
      index: null,
      value: null,
    },
  },
  {
    attribute: 'company->tech',
    dimension: {
      label: 'Clearbit Company Tech',
      index: null,
      value: null,
    },
  },
];

export function syncInProgress(accountConnector) {
  const remoteMeta = accountConnector?.remoteMeta;
  const syncStatus = remoteMeta?.syncStatus;

  switch (accountConnector?.service) {
    case configurations.salesforce:
    case configurations.salesforcesandbox:
    case configurations.hubspot:
      return !syncStatus || syncStatus === 'syncing';
    default:
      return false;
  }
}

export const accountConnectorServiceTrackName = (service) => {
  return serviceTrackNames[service] || service;
};

export const configurationNameForType = (type) => {
  switch (type) {
    case configurations.javascript:
      return 'JavaScript';
    case configurations.segment:
      return 'Segment';
    case configurations.google:
      return 'Google Analytics';
    case configurations.googleConversion:
      return 'Google Ad Conversions';
    case configurations.salesforce:
    case configurations.salesforcesandbox:
      return 'Salesforce';
    case configurations.slack:
      return 'Slack';
    case configurations.facebook:
      return 'Facebook';
    case configurations.hubspot:
      return 'HubSpot';
    case configurations.pardot:
      return 'Pardot';
    case configurations.marketo:
      return 'Marketo';
  }
};

export function purposeForConnectorService(service) {
  switch (service) {
    case configurations.salesforce:
    case configurations.salesforcesandbox:
      return 'syncing Salesforce data to Clearbit';
    case configurations.google:
      return 'mapping to Google Tag Manager';
    case configurations.googleConversion:
      return 'tracking conversion actions with Google Ads';
    case configurations.hubspot:
      return 'syncing Hubspot data to Clearbit';
    case configurations.slack:
      return 'triggering destinations to Slack';
    case configurations.facebook:
      return 'syncing Facebook audiences and destinations';
    case configurations.marketo:
      return 'enriching and shortening Marketo forms';
    default:
      return `utilizing ${capitalize(service)}`;
  }
}
